import api from "@/assets/js/api"; // 引用 API 模組
import Swal from "sweetalert2"; // 引入 SweetAlert2 用於彈出提示
export default {
  name: "MemberManagement",
  data() {
    return {
      members: [], // 會員資料
      searchQuery: "", // 搜尋關鍵字
      filteredMembers: [], // 搜尋後的資料
      currentPage: 1, // 當前頁數
      itemsPerPage: 10, // 每頁顯示數量
      idSortOrder: "asc", // ID 排序方式
      dateSortOrder: "asc", // 註冊日期排序方式 排序方式：'asc' 為升序, 'desc' 為降序
      showModal: false, // 控制模態框顯示
      showAddModal: false, // 控制新增會員的模態框
      selectedMember: {}, // 當前選中的會員資料
      newMember: {
        fullName: "",
        phone: "",
        email: "",
        birth: "",
        countries: "",
        locked: false,
      },
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.filteredMembers.length / this.itemsPerPage);
    },
    hasNextPage() {
      return this.currentPage < this.totalPages;
    },
    hasPreviousPage() {
      return this.currentPage > 1;
    },
    paginatedMembers() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;

      // 直接返回切片後的資料，不再生成新的 displayId
      return this.filteredMembers.slice(startIndex, endIndex);
    },
  },
  methods: {
    // 日期格式化函數
    formatDate(date) {
      if (!date) return ""; // 如果日期為空，返回空字串
      const formattedDate = new Date(date).toISOString().split("T")[0]; // 僅返回日期部分
      return formattedDate;
    },
    formatDateWithoutTimezone(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    // 加載員工資料
    async fetchMembers() {
      try {
        const response = await api.get("/Member/role1"); // 確保 API 返回的數據是 role = 1 的員工
        this.members = response.data.map((member) => ({
          ...member,
          birth: member.birth
            ? this.formatDateWithoutTimezone(member.birth)
            : "",
          createdAt: member.createdAt
            ? this.formatDateWithoutTimezone(member.createdAt)
            : "",
        }));
        this.filteredMembers = [...this.members];
        this.sortById(); // 按 ID 排序
      } catch (error) {
        console.error("獲取員工資料失敗:", error);
        Swal.fire({
          icon: "error",
          title: "錯誤",
          text: "無法獲取員工資料，請稍後再試！",
        });
      }
    },

    // 切換排序方式
    toggleSortOrder(field) {
      if (field === "id") {
        this.idSortOrder = this.idSortOrder === "asc" ? "desc" : "asc";
        this.sortById();
      } else if (field === "createdAt") {
        this.dateSortOrder = this.dateSortOrder === "asc" ? "desc" : "asc";
        this.sortByDate();
      }
    },

    //按id
    sortById() {
      this.filteredMembers.sort((a, b) => {
        return this.idSortOrder === "asc" ? a.id - b.id : b.id - a.id;
      });
    },

    //按註冊日期
    sortByDate() {
      this.filteredMembers.sort((a, b) => {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return this.dateSortOrder === "asc" ? dateA - dateB : dateB - dateA;
      });
    },

    // 搜尋會員
    filterMembers(query) {
      const keyword = query.trim().toLowerCase();
      this.filteredMembers = this.members.filter((member) =>
        member.email.toLowerCase().includes(keyword)
      );
      this.currentPage = 1; // 搜尋後重置為第一頁
    },

    // 過濾黑名單會員
    filterBlacklist() {
      this.filteredMembers = this.members.filter(
        (member) => member.locked === true
      );
      this.currentPage = 1; // 重置到第一頁
    },

    // 編輯會員
    editMember(member) {
      Swal.fire({
        icon: "info",
        title: "編輯會員",
        text: `編輯會員: ${member.name}`,
      });
    },
    // 刪除會員
    async deleteMember(id) {
      if (!confirm("確定要刪除這位會員嗎？")) return;

      try {
        const response = await api.delete(`/Member/${id}`);
        if (response.status === 200) {
          Swal.fire({
            icon: "success",
            title: "刪除成功",
            text: "會員刪除成功",
          });
          this.fetchMembers(); // 刪除後重新加載會員資料
        } else {
          Swal.fire({
            icon: "error",
            title: "刪除失敗",
            text: "刪除失敗，請稍後再試！",
          });
        }
      } catch (error) {
        console.error("刪除會員失敗:", error);
        Swal.fire({
          icon: "error",
          title: "錯誤",
          text: "無法刪除會員！",
        });
      }
    },
    // 回到員工清單頁
    goToMemberList() {
      if (this.$route.path === "/admin/employees") {
        // 如果已經在員工清單頁面，直接刷新資料
        this.fetchMembers(); // 再次加載資料
      } else {
        // 否則，跳轉到員工清單頁面
        this.$router.push("/admin/employees");
      }
    },
    // 顯示模態框
    showMemberDetails(member) {
      this.selectedMember = { ...member }; // 深拷貝選中會員資料
      this.showModal = true; // 顯示模態框
    },
    // 關閉模態框
    closeModal() {
      this.showModal = false;
      this.selectedMember = {}; // 清空選中會員資料
    },

    // 保存會員資料
    async saveMemberDetails() {
      try {
        // 驗證必填欄位
        if (!this.selectedMember.fullName || !this.selectedMember.email) {
          Swal.fire("欄位錯誤", "會員名稱與 Email 為必填！", "warning");
          return;
        }

        // 驗證電話格式
        const phoneRegex = /^\d{10}$/;
        if (!phoneRegex.test(this.selectedMember.phone)) {
          Swal.fire("格式錯誤", "電話必須是 10 碼！", "warning");
          return;
        }

        // 驗證 Email 格式
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.selectedMember.email)) {
          Swal.fire("格式錯誤", "請輸入合法的 Email！", "warning");
          return;
        }

        // 傳遞給後端的資料，僅保留必要的欄位
        const payload = {
          id: this.selectedMember.id,
          fullName: this.selectedMember.fullName,
          email: this.selectedMember.email,
          phone: this.selectedMember.phone || "N/A",
          countries: this.selectedMember.countries || "N/A",
          birth: this.selectedMember.birth,
          locked: this.selectedMember.locked,
          createdAt: this.selectedMember.createdAt,
        };

        console.log("[DEBUG] 發送給後端的資料:", payload);

        // 發送請求
        const response = await api.put(
          `/Member/${this.selectedMember.id}`,
          payload
        );

        if (response.status === 200) {
          Swal.fire("更新成功", "會員資料更新成功！", "success");
          this.closeModal(); // 關閉模態框
          this.fetchMembers(); // 重新加載會員列表
        } else {
          Swal.fire("更新失敗", "更新會員資料失敗，請稍後再試！", "error");
        }
      } catch (error) {
        // 捕獲錯誤並顯示詳細訊息
        console.error(
          "[ERROR] 更新會員資料失敗:",
          error.response || error.message
        );

        // 提取後端返回的錯誤訊息
        const backendError =
          error.response?.data?.errors || error.response?.data || {};
        console.error("[ERROR DETAILS] 後端錯誤詳細訊息:", backendError);

        // 提示具體錯誤訊息
        Swal.fire({
          icon: "error",
          title: "更新失敗",
          html: `錯誤訊息: ${
            backendError.message || "未知錯誤，請稍後再試。"
          }<br/><pre>${JSON.stringify(backendError, null, 2)}</pre>`,
          width: 600,
        });
      }
    },

    // 顯示新增會員模態框
    showAddMemberModal() {
      this.newMember = {
        fullName: "",
        phone: "",
        email: "",
        birth: "",
        countries: "",
        locked: false,
      };
      this.showAddModal = true;
    },

    // 關閉新增會員模態框
    closeAddModal() {
      this.showAddModal = false;
    },

    // 新增會員
    async addMember() {
      // 1/11 加入
      // 驗證電話是否為 10 碼
      const phoneRegex = /^\d{10}$/;
      if (!phoneRegex.test(this.newMember.phone)) {
        Swal.fire("格式錯誤", "電話號碼必須為 10 碼！", "warning");
        return;
      }

      // 1/11 加入
      // 驗證 Email 格式
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.newMember.email)) {
        Swal.fire("格式錯誤", "請輸入正確的 Email 格式！", "warning");
        return;
      }

      try {
        const response = await api.post("/Member", this.newMember);
        if (response.status === 200) {
          Swal.fire("新增成功", "會員新增成功！", "success");
          this.closeAddModal();
          this.fetchMembers(); // 重新載入會員資料
        } else {
          Swal.fire("新增失敗", "會員新增失敗！", "error");
        }
      } catch (error) {
        console.error("新增會員失敗：", error);
        Swal.fire("錯誤", "新增會員失敗，請稍後再試！", "error");
      }
    },

    // 分頁操作
    prevPage() {
      if (this.hasPreviousPage) this.currentPage--;
    },
    nextPage() {
      if (this.hasNextPage) this.currentPage++;
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
  created() {
    this.fetchMembers();
  },
  watch: {
    searchQuery: {
      immediate: true,
      handler(query) {
        this.filterMembers(query);
      },
    },
  },
};
